import styled from 'styled-components';

export const ContactContainer = styled.section`
color:white;
font-size:5rem;
position:relative;
text-align: center;
`